import Sound from './Sound';
let music = new Sound('mainTheme');
export default music;
